import accessToken from "../../helpers/accessToken";
import Mixins from "../../mixins/GlobalMixins";
import API_URL from "../../helpers/apiUrls";
import router from '../../router/index'

const state = {
    productCategories : {
        total : 0,
        data : [],
    },

    brandList : {
        total : 0,
        data : []
    },

    historicalProducts : {
        total : 0,
        data : []
    },

    masterProducts : {
        total : 0,
        data : []
    },

    addProductModalPaginationData : {
        page : 1,
        perPage : 100
    },

    radioLoader : false // The loader for add product modal.
}

const mutations = {
    SET_PRODUCT_CATEGORIES : (state, value) => {
        if(state.addProductModalPaginationData.page > 1) {
            state.productCategories.data = [...state.productCategories.data, ...value.results];
        }
        else {
            state.productCategories.data = value.results;
        }
        state.productCategories.total = value.count;
    },

    SET_BRAND_LIST : (state, value) => {
        if(state.addProductModalPaginationData.page > 1) {
            state.brandList.data = [...state.brandList.data, ...value.results];
        }
        else {
            state.brandList.data = value.results;
        }
        state.brandList.total = value.count;
    },

    SET_HISTORICAL_PRODUCTS : (state, value) => {
        const newArray = value.results.map(result => {
            return {
                id : result.id,
                name : result.product_name,
                weight : result.product_size,
                image : result.images.length ? result.images[0].image : ''
            }
        });
        if(state.addProductModalPaginationData.page > 1) {
            state.historicalProducts.data = [...state.historicalProducts.data, ...newArray];
        }
        else {
            state.historicalProducts.data = newArray;
        }
        state.historicalProducts.total = value.count;
    },

    SET_MASTER_PRODUCTS : (state, value) => {
        const newArray = value.results.map(result => {
            return {
                id : result.id,
                name : result.product_name,
                weight : result.product_size,
                image : result.images.length ? result.images[0].image : ''
            }
        });
        if(state.addProductModalPaginationData.page > 1) {
            state.masterProducts.data = [...state.masterProducts.data, ...newArray];
        }
        else {
            state.masterProducts.data = newArray;
        }
        state.masterProducts.total = value.count;
    }
}

const actions = {
    getProductCategories({commit, state, dispatch}) {
        dispatch('mainStore/toggleLoader', true, {root : true});
        const successHandler = response => {
            if(response.status == 200) {
                dispatch('mainStore/toggleLoader', false, {root : true});
                commit('SET_PRODUCT_CATEGORIES', response.data);
            }
        }

        const errorHandler = error => {
            console.log(error);
        }

        const headers = {
            'Authorization' : `Bearer ${accessToken.getAccessToken()}` 
        }

        const data = {
            page : state.addProductModalPaginationData.page,
            data_per_page : state.addProductModalPaginationData.perPage
        }

        Mixins.methods.requestGET(
            API_URL.products__categories,
            data,
            headers,
            successHandler,
            errorHandler
        )
    },

    getBrandList({commit, state, dispatch}, query) {
        state.radioLoader = true;
        const successHandler = response => {
            state.radioLoader = false;
            if(response.status == 200) {
                commit('SET_BRAND_LIST', response.data);
            }
        }

        const errorHandler = error => {
            const snackBarData = {
                textMessage : 'Something went wrong internally!',
                color : 'error',
                timeOut : 10000
            }
            dispatch('mainStore/setSnackBar', snackBarData, {root : true});
            state.radioLoader = false;
            console.log(error);
        }

        const data = {
            category_id : query,
            page : state.addProductModalPaginationData.page,
            data_per_page : state.addProductModalPaginationData.perPage
        }

        const headers = {
            'Authorization' : `Bearer ${accessToken.getAccessToken()}` 
        }

        Mixins.methods.requestGET(
            API_URL.products__brandList,
            data,
            headers,
            successHandler,
            errorHandler
        )
    },

    getHistoricalProductList({dispatch, commit, state}, query) {
        state.radioLoader = true;
        const successHandler = response => {
            state.radioLoader = false;
            if(response.status == 200) {
                commit('SET_HISTORICAL_PRODUCTS', response.data);
            }
        }

        const errorHandler = error => {
            const snackBarData = {
                textMessage : 'Something went wrong internally!',
                color : 'error',
                timeOut : 10000
            }
            dispatch('mainStore/setSnackBar', snackBarData, {root : true});
            state.radioLoader = false;
            console.log(error);
        }

        const data = {
            category : query,
            page : state.addProductModalPaginationData.page,
            data_per_page : state.addProductModalPaginationData.perPage
        }

        const headers = {
            'Authorization' : `Bearer ${accessToken.getAccessToken()}` 
        }

        Mixins.methods.requestGET(
            API_URL.products__historicalProducts,
            data,
            headers,
            successHandler,
            errorHandler
        )
    },

    getMasterProductList({dispatch, commit, state}, payload) {
        state.radioLoader = true;
        const successHandler = response => {
            state.radioLoader = false;
            if(response.status == 200) {
                commit('SET_MASTER_PRODUCTS', response.data);
            }
        }

        const errorHandler = error => {
            const snackBarData = {
                textMessage : 'Something went wrong internally!',
                color : 'error',
                timeOut : 10000
            }
            dispatch('mainStore/setSnackBar', snackBarData, {root : true});
            state.radioLoader = false;
            console.log(error);
        }

        const data = {
            category_id : payload.categoryID,
            brand_id : payload.brandID,
            page : state.addProductModalPaginationData.page,
            data_per_page : state.addProductModalPaginationData.perPage
        }

        const headers = {
            'Authorization' : `Bearer ${accessToken.getAccessToken()}` 
        }

        Mixins.methods.requestGET(
            API_URL.products__masterProducts,
            data,
            headers,
            successHandler,
            errorHandler
        )
    },


}

const getters = {
    GET_PRODUCT_CATEGORIES : state => state.productCategories,

    GET_BRAND_LIST : state => state.brandList,

    GET_HISTORICAL_PRODUCTS : state => state.historicalProducts,

    GET_MASTER_PRODUCTS : state => state.masterProducts,

    GET_PAGINATION_DATA : state => state.addProductModalPaginationData
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};